module.exports = __webpack_public_path__ + "img/wealth.9757d5e8.png";